import { css } from '@emotion/react';

export default css`
  .light-mode {
    --primary-background-color: var(--system-background-app-light);
    --primary-contrast-color: var(--system-text-primary-dark);
    --primary-text-color: var(--system-text-primary-light);
    --primary-text-color-nav-items-change: var(--system-text-primary-light);
    --primary-hover-color: var(--system-background-selected-low-contrast-light);

    --secondary-background-color: var(--system-background-surface-1-light);
    --secondary-text-color: var(--system-text-secondary-light);
    --secondary-text-color-inverted: var(
      --system-text-secondary-inverted-light
    );

    --muted-text: var(--system-text-muted-light);

    --modal-background-color: var(--secondary-background-color);
    --modal-wrapper-color: var(--modal-wrapper-background-light);

    --button-background-color: var(--primary-text-color);
    --button-outline-color: var(--color-black);
    --button-text-color: var(--color-white);

    --accent-text-color: var(--secondary-text-color);
    --link-color: var(--interactive-link-light);
    --link-hover-color: #009eff;
    --border-color: var(--system-border-strong-light);
    --divider-color: var(--system-background-selected-low-contrast-light);
    --heading-text-color: var(--primary-text-color);

    --callout-caution-background-color: #fce9e935;
    --callout-important-background-color: #fff9cc30;
    --callout-tip-background-color: #f8fef9;
    --callout-course-background-color: #00b3c310;

    input::placeholder {
      color: var(--primary-text-color);
      opacity: 80%;
    }

    *:not(pre) > code,
    var {
      background: var(--system-background-muted-light);
    }
  }
`;
